import { get } from 'lodash';

export const isPurchaseLimitsExceeded = state => get(state, 'summary.purchaseLimitsExceeded');
export const getTicketTotals = state => get(state, 'summary.summary.ticketTotals', undefined);


// WEBPACK FOOTER //
// ./src/selectors/summary_selectors.jsx